import { useEffect, useState } from "react";
import "./index.css";
import { useCmsSlider } from "../../context/CmsSliderContext";

export default function CmsSliderOverlay() {
  const { isOpenSlider, setIsOpenSlider } = useCmsSlider();
  const [currentIndex, setCurrentIndex] = useState(isOpenSlider.index);
  const brandsData = isOpenSlider.slides;

  console.log(brandsData);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % brandsData.length);
  };

  const goToPrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + brandsData.length) % brandsData.length
    );
  };

  useEffect(() => {
    if (isOpenSlider.show && currentIndex !== isOpenSlider.index) {
      setCurrentIndex(isOpenSlider.index);
    }
  }, [isOpenSlider.show]);

  useEffect(() => {
    document.body.style.overflow = isOpenSlider.show ? "hidden" : "";
  }, [isOpenSlider.show]);

  return (
    <>
      {isOpenSlider?.show && (
        <>
          {/* Overlay Background */}
          <div className="fixed top-0 left-0 z-40 w-full h-full bg-[#333] opacity-95"></div>

          {/* Slider Content */}
          <div className="fixed top-0 left-0 z-50 w-full h-full py-[40px]">
            <div className="absolute px-[8px] left-0 top-0 text-center w-full h-full before:content-[''] before:inline-block before:h-full before:align-middle">
              <div className="relative inline-block w-auto h-[auto]">
                <span
                  onClick={() =>
                    setIsOpenSlider({ show: false, index: 0, slides: [] })
                  }
                  className="text-white opacity-65 absolute text-[20px] right-[4px] -top-[32px] hover:opacity-100 cursor-pointer font-arial"
                >
                  x
                </span>
                <img
                  onClick={goToNext}
                  className="inline-block object-cover w-auto max-h-[542px] md:max-h-[673px] cursor-pointer"
                  src={brandsData[currentIndex]}
                  alt={`Brand Logo ${currentIndex + 1}`}
                />
                <div className="block text-[#ccc] text-[12px] absolute -bottom-[25px] font-open right-0">{`${
                  currentIndex + 1
                } of ${brandsData.length}`}</div>
              </div>
              <button onClick={goToPrevious} className="btn btn-left"></button>
              <button onClick={goToNext} className="btn btn-right"></button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
